import { DomesticPriceAddress } from "../schemas/calculatePriceSchema";
import { searchCompanyCustomers } from "../services";

export const hasCompanyInDomesticSystem = async (
  companyRegNo: string | null
): Promise<boolean> => {
  if (!companyRegNo) return false;
  try {
    const customers = await searchCompanyCustomers(companyRegNo);
    return customers.length > 0;
  } catch {
    return false;
  }
};

export const getServiceArea = (
  locations: DomesticPriceAddress[],
  city: string
): string | undefined => {
  return locations.find((l) => l.value === city)?.defaultAddress;
};
